import axiosClient from "./axiosClient";

const chatbotEventAccessApi = {
  getMyAccess: (accountId) =>
    axiosClient.get("/chatbot-event/me", {
      params: { accountId },
    }),

  updateAccountAccess: (accountId, data) =>
    axiosClient.patch(`/chatbot-event/accounts/${accountId}/enabled`, data),
};

export default chatbotEventAccessApi;
